

import './App.css';
// import GoTop from './components/GoTop';

// import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useState } from 'react'
import Myself from './components/Myself';
import Top from './components/Top';
import Work from './components/Work';
import Data from "./components/Data"
import Contact from "./components/Contact"
import Client from "./components/Client"
import Certificate from './components/Certificate';
import GoTop from './components/GoTop';





function App() {

  const [data , setData] = useState(Data);
 
  return (
   <>
    <GoTop/>
     <Top/>
   {/* <GoTop/> */}
  
    <Myself id  = "myself"/> 

    <Work MyData = {data}/>
  <Certificate/>
  <Client/>
   <Contact/>
  
   </>
  );
}

export default App;
